module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/3@2x_1774461fb79cf9665008a8de5549b33a.png";